import React, { useState } from "react";
import "./JobApplicationForm.css";
import { Link } from "react-router-dom";


const JobApplicationForm = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    uploadOption: "",
    message: "",
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.agree) return alert("You must agree to the terms.");
    console.log("Submitted application:", form);
  };

  return (
    <form className="job-application-form" onSubmit={handleSubmit}>
      <h2>Apply for this role</h2>
      <div className="form-header">
        <p>Send <b>CV</b> to <span className="email">info@asg.org.gh</span> with subject: <b>LIFE INSURANCE ACTUARY</b></p>
        <p>Or </p>
        <p>Fill the form bellow</p>


      </div>
      <div className="form-row">
        <input
          type="text"
          name="firstName"
          placeholder="First name"
          value={form.firstName}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last name"
          value={form.lastName}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-row">
        <input
          type="tel"
          name="phone"
          placeholder="Telephone number"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email address"
          value={form.email}
          onChange={handleChange}
          required
        />
      </div>
      <select
        name="uploadOption"
        value={form.uploadOption}
        onChange={handleChange}
        required
      >
        <option value="">Select upload option</option>
        <option value="cv">CV</option>
        <option value="linkedin">LinkedIn</option>
        <option value="dropbox">Dropbox</option>
      </select>
      <textarea
        name="message"
        placeholder="Message"
        value={form.message}
        onChange={handleChange}
        rows={5}
      />
      <div className="form-checkbox">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            name="agree"
            checked={form.agree}
            onChange={handleChange}
          />
          <span className="checkbox_box" />
          <p className="submition-agreement">
              By submitting this form, you agree to our{" "}
            <Link  href="#">Cookies & Privacy Policy</Link> &{" "}
            <Link href="#">Terms & Conditions</Link>
          </p>
        </label>
      </div>
      <button type="submit" className="form-apply-btn">Apply now</button>

    </form>
  );
};

export default JobApplicationForm;
